module.exports = __webpack_public_path__ + "img/20201102_driving_innovations_in_open_banking.941de451.jpg";